import React from "react";
import SearchWidget from "../form/search/SearchWidget";

function MainPage() {
    return (
        <div>
            <SearchWidget mainPage={true}/>
        </div>
    );
}

export default MainPage;
